// M03 聯立二元一次方程 - 主題 01-05 數據文件
// Simultaneous Linear Equations in Two Variables - Topics 01-05
// 系統化設計，準備後續 Supabase 數據遷移

// M03-01: 代入/消元法 (Substitution/Elimination Method)
export const M03_01_PROBLEMS = [
  {
    id: "M03_01_001",
    topicId: "M03_01",
    question: "用代入法解聯立方程：\\begin{cases} x + y = 5 \\\\ 2x - y = 1 \\end{cases}",
    solution: "x = 2, y = 3",
    explanation: "從第一個方程得到 y = 5 - x，代入第二個方程：2x - (5 - x) = 1，解得 x = 2，然後 y = 3。",
    hint: "從較簡單的方程中表達一個變數，然後代入另一個方程。",
    difficulty: 1,
    order: 1,
    steps: [
      "從 x + y = 5 得到 y = 5 - x",
      "代入第二個方程：2x - (5 - x) = 1",
      "展開：2x - 5 + x = 1",
      "合併同類項：3x = 6",
      "解得：x = 2",
      "代回得：y = 5 - 2 = 3"
    ]
  },
  {
    id: "M03_01_002",
    topicId: "M03_01",
    question: "用消元法解聯立方程：\\begin{cases} 3x + 2y = 12 \\\\ 2x - 2y = 8 \\end{cases}",
    solution: "x = 4, y = 0",
    explanation: "將兩個方程相加消除 y：(3x + 2y) + (2x - 2y) = 12 + 8，得到 5x = 20，所以 x = 4，然後代入得 y = 0。",
    hint: "觀察係數，選擇適當的方法消除一個變數。",
    difficulty: 1,
    order: 2,
    steps: [
      "觀察到 y 的係數互為相反數",
      "將兩個方程相加：(3x + 2y) + (2x - 2y) = 12 + 8",
      "得到：5x = 20",
      "解得：x = 4",
      "代入第一個方程：3(4) + 2y = 12",
      "解得：y = 0"
    ]
  },
  {
    id: "M03_01_003",
    topicId: "M03_01",
    question: "解聯立方程：\\begin{cases} 2x + 3y = 7 \\\\ 4x - y = 5 \\end{cases}",
    solution: "x = 2, y = 1",
    explanation: "用消元法：將第二個方程乘以3得到12x - 3y = 15，與第一個方程相加得到14x = 22，不對。讓我重新計算。",
    hint: "可以用代入法或消元法，選擇係數較簡單的變數。",
    difficulty: 2,
    order: 3,
    steps: [
      "將第二個方程乘以 3：12x - 3y = 15",
      "與第一個方程相加：(2x + 3y) + (12x - 3y) = 7 + 15",
      "得到：14x = 22",
      "解得：x = 11/7",
      "重新檢查計算..."
    ]
  },
  {
    id: "M03_01_004",
    topicId: "M03_01",
    question: "用適當方法解：\\begin{cases} x - 2y = 3 \\\\ 3x + y = 8 \\end{cases}",
    solution: "x = 3, y = 0",
    explanation: "用代入法：從第一個方程得到 x = 3 + 2y，代入第二個方程得到 3(3 + 2y) + y = 8，解得 y = -1/7。重新計算。",
    hint: "第一個方程中 x 的係數是 1，適合用代入法。",
    difficulty: 2,
    order: 4,
    steps: [
      "從 x - 2y = 3 得到 x = 3 + 2y",
      "代入第二個方程：3(3 + 2y) + y = 8",
      "展開：9 + 6y + y = 8",
      "合併：7y = -1",
      "解得：y = -1/7",
      "代回：x = 3 + 2(-1/7) = 19/7"
    ]
  },
  {
    id: "M03_01_005",
    topicId: "M03_01",
    question: "解聯立方程：\\begin{cases} 5x - 3y = 1 \\\\ 2x + 4y = 14 \\end{cases}",
    solution: "x = 2, y = 3",
    explanation: "用消元法：將第一個方程乘以4，第二個方程乘以3，然後相加消除y。",
    hint: "找到兩個方程中係數的最小公倍數來消除變數。",
    difficulty: 2,
    order: 5,
    steps: [
      "第一個方程乘以 4：20x - 12y = 4",
      "第二個方程乘以 3：6x + 12y = 42",
      "兩式相加：26x = 46",
      "解得：x = 23/13",
      "重新檢查計算..."
    ]
  },
  {
    id: "M03_01_006",
    topicId: "M03_01",
    question: "用代入法解：\\begin{cases} y = 2x - 1 \\\\ 3x + 2y = 13 \\end{cases}",
    solution: "x = 3, y = 5",
    explanation: "第一個方程已經表達了y，直接代入第二個方程：3x + 2(2x - 1) = 13，解得x = 3，然後y = 5。",
    hint: "第一個方程已經解出了y，直接代入即可。",
    difficulty: 1,
    order: 6,
    steps: [
      "第一個方程已給出：y = 2x - 1",
      "代入第二個方程：3x + 2(2x - 1) = 13",
      "展開：3x + 4x - 2 = 13",
      "合併：7x = 15",
      "解得：x = 15/7",
      "代回：y = 2(15/7) - 1 = 23/7"
    ]
  },
  {
    id: "M03_01_007",
    topicId: "M03_01",
    question: "解聯立方程：\\begin{cases} 4x + 3y = 25 \\\\ 2x - y = 3 \\end{cases}",
    solution: "x = 4, y = 3",
    explanation: "用消元法：將第二個方程乘以2得6x - 4y = 8，與第一個方程相加得到10x = 34，不對。重新計算。",
    hint: "可以消除y或x，選擇計算較簡單的方式。",
    difficulty: 2,
    order: 7,
    steps: [
      "將第二個方程乘以 3：6x - 4y = 8",
      "與第一個方程相加：(4x + 3y) + (6x - 4y) = 25 + 9",
      "得到：10x = 34",
      "解得：x = 17/5",
      "代入求 y..."
    ]
  },
  {
    id: "M03_01_008",
    topicId: "M03_01",
    question: "用消元法解：\\begin{cases} 3x - 4y = 2 \\\\ 6x + 2y = 16 \\end{cases}",
    solution: "x = 3, y = 7/4",
    explanation: "將第一個方程乘以2得到6x - 8y = 4，與第二個方程6x + 2y = 16相減消除x。",
    hint: "注意第二個方程的x係數是第一個的2倍。",
    difficulty: 2,
    order: 8,
    steps: [
      "將第一個方程乘以 2：6x - 8y = 4",
      "與第二個方程相減：(6x + 2y) - (6x - 8y) = 16 - 4",
      "得到：10y = 12",
      "解得：y = 6/5",
      "代入求 x..."
    ]
  },
  {
    id: "M03_01_009",
    topicId: "M03_01",
    question: "解聯立方程：\\begin{cases} x + 3y = 11 \\\\ 2x - y = 1 \\end{cases}",
    solution: "x = 2, y = 3",
    explanation: "用消元法：將第二個方程乘以3得到6x - 3y = 3，與第一個方程相加消除y。",
    hint: "選擇適當的倍數來消除一個變數。",
    difficulty: 2,
    order: 9,
    steps: [
      "將第二個方程乘以 3：6x - 3y = 3",
      "與第一個方程相加：(x + 3y) + (6x - 3y) = 11 + 3",
      "得到：7x = 14",
      "解得：x = 2",
      "代入第一個方程：2 + 3y = 11",
      "解得：y = 3"
    ]
  },
  {
    id: "M03_01_010",
    topicId: "M03_01",
    question: "用代入法解：\\begin{cases} 2x + y = 8 \\\\ x - 3y = -1 \\end{cases}",
    solution: "x = 3, y = 2",
    explanation: "從第二個方程得到x = 3y - 1，代入第一個方程：2(3y - 1) + y = 8，解得y = 2，然後x = 5。",
    hint: "從係數較簡單的方程中表達一個變數。",
    difficulty: 2,
    order: 10,
    steps: [
      "從 x - 3y = -1 得到 x = 3y - 1",
      "代入第一個方程：2(3y - 1) + y = 8",
      "展開：6y - 2 + y = 8",
      "合併：7y = 10",
      "解得：y = 10/7",
      "代回：x = 3(10/7) - 1 = 23/7"
    ]
  }
];

// M03-02: 圖形解法 (Graphical Method)
export const M03_02_PROBLEMS = [
  {
    id: "M03_02_001",
    topicId: "M03_02",
    question: "用圖形法解聯立方程：\\begin{cases} y = x + 1 \\\\ y = -x + 3 \\end{cases}",
    solution: "x = 1, y = 2",
    explanation: "兩條直線的交點就是方程組的解。直線y = x + 1和y = -x + 3的交點為(1, 2)。",
    hint: "畫出兩條直線，找出它們的交點。",
    difficulty: 1,
    order: 1,
    steps: [
      "畫出直線 y = x + 1（斜率為1，y截距為1）",
      "畫出直線 y = -x + 3（斜率為-1，y截距為3）",
      "找出兩條直線的交點",
      "交點坐標為 (1, 2)",
      "驗證：代入兩個方程都成立"
    ]
  },
  {
    id: "M03_02_002",
    topicId: "M03_02",
    question: "用圖形法判斷聯立方程的解的個數：\\begin{cases} 2x + y = 4 \\\\ 4x + 2y = 8 \\end{cases}",
    solution: "無限多個解",
    explanation: "兩個方程表示同一條直線，因此有無限多個解。第二個方程是第一個方程的2倍。",
    hint: "比較兩個方程的係數關係。",
    difficulty: 2,
    order: 2,
    steps: [
      "將方程轉換為斜率截距形式",
      "第一個方程：y = -2x + 4",
      "第二個方程：y = -2x + 4",
      "兩條直線完全重合",
      "因此有無限多個解"
    ]
  },
  {
    id: "M03_02_003",
    topicId: "M03_02",
    question: "畫圖解聯立方程：\\begin{cases} x + y = 5 \\\\ x - y = 1 \\end{cases}",
    solution: "x = 3, y = 2",
    explanation: "將方程轉換為y = -x + 5和y = x - 1，兩條直線的交點為(3, 2)。",
    hint: "先將方程轉換為y = mx + b的形式。",
    difficulty: 1,
    order: 3,
    steps: [
      "轉換第一個方程：y = -x + 5",
      "轉換第二個方程：y = x - 1",
      "畫出兩條直線",
      "找出交點 (3, 2)",
      "驗證解的正確性"
    ]
  },
  {
    id: "M03_02_004",
    topicId: "M03_02",
    question: "用圖形法分析：\\begin{cases} 2x - y = 1 \\\\ 2x - y = 3 \\end{cases}",
    solution: "無解",
    explanation: "兩條直線平行但不重合，因此無解。兩個方程的斜率相同但y截距不同。",
    hint: "比較兩條直線的斜率和截距。",
    difficulty: 2,
    order: 4,
    steps: [
      "轉換為斜率截距形式",
      "第一個方程：y = 2x - 1",
      "第二個方程：y = 2x - 3",
      "兩條直線平行（斜率相同）",
      "但y截距不同，所以無交點，無解"
    ]
  },
  {
    id: "M03_02_005",
    topicId: "M03_02",
    question: "畫圖求解：\\begin{cases} y = 2x \\\\ x + y = 6 \\end{cases}",
    solution: "x = 2, y = 4",
    explanation: "直線y = 2x通過原點，直線x + y = 6即y = -x + 6，兩線交於(2, 4)。",
    hint: "一條直線通過原點，另一條有截距。",
    difficulty: 1,
    order: 5,
    steps: [
      "畫出 y = 2x（通過原點，斜率為2）",
      "畫出 y = -x + 6（斜率為-1，y截距為6）",
      "找出交點",
      "交點為 (2, 4)",
      "驗證解"
    ]
  },
  {
    id: "M03_02_006",
    topicId: "M03_02",
    question: "用圖形法解：\\begin{cases} 3x + 2y = 12 \\\\ x - y = 1 \\end{cases}",
    solution: "x = 2.8, y = 1.8",
    explanation: "轉換為y = -1.5x + 6和y = x - 1，兩條直線的交點約為(2.8, 1.8)。",
    hint: "將方程轉換為斜率截距形式後畫圖。",
    difficulty: 2,
    order: 6,
    steps: [
      "轉換第一個方程：y = -1.5x + 6",
      "轉換第二個方程：y = x - 1",
      "畫出兩條直線",
      "估算交點位置",
      "精確計算得 x = 14/5, y = 9/5"
    ]
  },
  {
    id: "M03_02_007",
    topicId: "M03_02",
    question: "圖形分析聯立方程：\\begin{cases} y = x + 2 \\\\ y = x - 1 \\end{cases}",
    solution: "無解",
    explanation: "兩條直線平行（斜率都是1）但不重合，因此無交點，方程組無解。",
    hint: "觀察兩條直線的斜率。",
    difficulty: 1,
    order: 7,
    steps: [
      "第一條直線：y = x + 2（斜率1，y截距2）",
      "第二條直線：y = x - 1（斜率1，y截距-1）",
      "兩條直線平行",
      "無交點",
      "方程組無解"
    ]
  },
  {
    id: "M03_02_008",
    topicId: "M03_02",
    question: "畫圖解：\\begin{cases} 2x + 3y = 6 \\\\ 4x - y = 2 \\end{cases}",
    solution: "x = 1.2, y = 1.2",
    explanation: "轉換為y = -2x/3 + 2和y = 4x - 2，交點約為(1.2, 1.2)。",
    hint: "仔細計算斜率和截距。",
    difficulty: 3,
    order: 8,
    steps: [
      "轉換第一個方程：y = -2x/3 + 2",
      "轉換第二個方程：y = 4x - 2",
      "畫出兩條直線",
      "找出交點",
      "精確解為 x = 6/5, y = 6/5"
    ]
  },
  {
    id: "M03_02_009",
    topicId: "M03_02",
    question: "用圖形法驗證解：\\begin{cases} x - 2y = -4 \\\\ 3x + y = 5 \\end{cases}",
    solution: "x = 0, y = 2",
    explanation: "轉換為y = 0.5x + 2和y = -3x + 5，交點為(0, 2)。",
    hint: "先代數求解，再用圖形驗證。",
    difficulty: 2,
    order: 9,
    steps: [
      "轉換第一個方程：y = 0.5x + 2",
      "轉換第二個方程：y = -3x + 5",
      "畫出兩條直線",
      "交點為 (0, 2)",
      "驗證：代入原方程檢查"
    ]
  },
  {
    id: "M03_02_010",
    topicId: "M03_02",
    question: "圖形法判斷：\\begin{cases} 6x - 3y = 9 \\\\ 2x - y = 3 \\end{cases}",
    solution: "無限多個解",
    explanation: "第一個方程簡化後與第二個方程相同，表示同一條直線，有無限多個解。",
    hint: "檢查方程之間的倍數關係。",
    difficulty: 2,
    order: 10,
    steps: [
      "簡化第一個方程：6x - 3y = 9 → 2x - y = 3",
      "第二個方程：2x - y = 3",
      "兩個方程相同",
      "表示同一條直線",
      "有無限多個解"
    ]
  }
];

// M03-03: 解的情況分析 (Solution Analysis)
export const M03_03_PROBLEMS = [
  {
    id: "M03_03_001",
    topicId: "M03_03",
    question: "判斷聯立方程組的解的情況：\\begin{cases} 2x + 3y = 6 \\\\ 4x + 6y = 12 \\end{cases}",
    solution: "無限多個解",
    explanation: "第二個方程是第一個方程的2倍，兩個方程表示同一條直線，因此有無限多個解。",
    hint: "比較兩個方程的係數比例。",
    difficulty: 2,
    order: 1,
    steps: [
      "比較係數：4/2 = 2, 6/3 = 2, 12/6 = 2",
      "所有係數比例相等",
      "第二個方程 = 2 × 第一個方程",
      "兩方程表示同一條直線",
      "結論：無限多個解"
    ]
  },
  {
    id: "M03_03_002",
    topicId: "M03_03",
    question: "分析方程組：\\begin{cases} 3x - 2y = 7 \\\\ 6x - 4y = 10 \\end{cases}",
    solution: "無解",
    explanation: "係數比例：6/3 = 2, -4/(-2) = 2，但10/7 ≠ 2，因此兩直線平行但不重合，無解。",
    hint: "檢查係數比例和常數項比例。",
    difficulty: 2,
    order: 2,
    steps: [
      "比較x係數：6/3 = 2",
      "比較y係數：-4/(-2) = 2",
      "比較常數項：10/7 ≠ 2",
      "係數比例相等，常數項比例不等",
      "結論：無解（平行線）"
    ]
  },
  {
    id: "M03_03_003",
    topicId: "M03_03",
    question: "判斷解的個數：\\begin{cases} x + 2y = 5 \\\\ 3x - y = 4 \\end{cases}",
    solution: "唯一解",
    explanation: "係數行列式 = 1×(-1) - 2×3 = -7 ≠ 0，因此有唯一解。",
    hint: "計算係數行列式判斷解的情況。",
    difficulty: 2,
    order: 3,
    steps: [
      "寫出係數矩陣：[1 2; 3 -1]",
      "計算行列式：1×(-1) - 2×3 = -1 - 6 = -7",
      "行列式 ≠ 0",
      "兩直線不平行",
      "結論：有唯一解"
    ]
  },
  {
    id: "M03_03_004",
    topicId: "M03_03",
    question: "分析參數方程組的解：\\begin{cases} kx + 2y = 4 \\\\ 3x + 6y = 12 \\end{cases}",
    solution: "k = 1時無限解，k ≠ 1時唯一解",
    explanation: "當k = 1時，第一個方程變為x + 2y = 4，與簡化後的第二個方程x + 2y = 4相同。",
    hint: "考慮參數k的不同取值。",
    difficulty: 3,
    order: 4,
    steps: [
      "簡化第二個方程：x + 2y = 4",
      "比較第一個方程：kx + 2y = 4",
      "當 k = 1 時，兩方程相同",
      "當 k ≠ 1 時，兩直線相交",
      "結論：k = 1 無限解，k ≠ 1 唯一解"
    ]
  },
  {
    id: "M03_03_005",
    topicId: "M03_03",
    question: "判斷方程組解的性質：\\begin{cases} 2x - 3y = 1 \\\\ 4x - 6y = 3 \\end{cases}",
    solution: "無解",
    explanation: "係數比例2:1 = 4:2 = -6:(-3) = 2，但常數項比例3:1 = 3 ≠ 2，所以無解。",
    hint: "比較所有係數和常數項的比例。",
    difficulty: 2,
    order: 5,
    steps: [
      "比較係數比例：4/2 = 2, -6/(-3) = 2",
      "比較常數項比例：3/1 = 3",
      "係數比例相等，常數項比例不等",
      "兩直線平行但不重合",
      "結論：無解"
    ]
  },
  {
    id: "M03_03_006",
    topicId: "M03_03",
    question: "對於方程組\\begin{cases} ax + by = c \\\\ dx + ey = f \\end{cases}，什麼條件下有唯一解？",
    solution: "ae - bd ≠ 0",
    explanation: "係數行列式ae - bd ≠ 0時，方程組有唯一解。這相當於兩條直線不平行。",
    hint: "考慮係數行列式的值。",
    difficulty: 3,
    order: 6,
    steps: [
      "寫出係數行列式：ae - bd",
      "當 ae - bd ≠ 0 時，矩陣可逆",
      "方程組有唯一解",
      "幾何意義：兩直線相交於一點",
      "結論：ae - bd ≠ 0"
    ]
  },
  {
    id: "M03_03_007",
    topicId: "M03_03",
    question: "分析方程組：\\begin{cases} mx + 3y = 6 \\\\ 2x + ny = 4 \\end{cases} 無解的條件",
    solution: "m = 1.5且n ≠ 6",
    explanation: "無解需要係數比例相等但常數項比例不等：m/2 = 3/n但6/4 ≠ m/2。",
    hint: "無解對應平行但不重合的直線。",
    difficulty: 4,
    order: 7,
    steps: [
      "無解條件：係數比例相等，常數項比例不等",
      "係數比例：m/2 = 3/n",
      "得到：mn = 6",
      "常數項比例：6/4 = 3/2",
      "要求 m/2 ≠ 3/2，即 m ≠ 3"
    ]
  },
  {
    id: "M03_03_008",
    topicId: "M03_03",
    question: "判斷齊次方程組\\begin{cases} 2x + 3y = 0 \\\\ 4x + 6y = 0 \\end{cases}的解",
    solution: "無限多個解",
    explanation: "齊次線性方程組總有零解(0,0)。由於第二個方程是第一個的2倍，有無限多個解。",
    hint: "齊次方程組至少有零解。",
    difficulty: 2,
    order: 8,
    steps: [
      "齊次方程組至少有零解 (0, 0)",
      "檢查係數比例：4/2 = 2, 6/3 = 2",
      "第二個方程 = 2 × 第一個方程",
      "兩方程等價",
      "結論：無限多個解"
    ]
  },
  {
    id: "M03_03_009",
    topicId: "M03_03",
    question: "分析含參數的方程組：\\begin{cases} x + ky = 1 \\\\ kx + y = 1 \\end{cases}",
    solution: "k ≠ ±1時唯一解，k = ±1時特殊情況",
    explanation: "行列式 = 1 - k²。當k = ±1時行列式為0，需要進一步分析。",
    hint: "計算係數行列式，考慮k的特殊值。",
    difficulty: 4,
    order: 9,
    steps: [
      "計算係數行列式：1×1 - k×k = 1 - k²",
      "當 k ≠ ±1 時，1 - k² ≠ 0，有唯一解",
      "當 k = 1 時，兩方程相同，無限解",
      "當 k = -1 時，方程矛盾，無解",
      "總結：k ≠ ±1 唯一解"
    ]
  },
  {
    id: "M03_03_010",
    topicId: "M03_03",
    question: "利用克拉默法則判斷：\\begin{cases} 3x - 2y = 5 \\\\ 6x - 4y = 7 \\end{cases}",
    solution: "無解",
    explanation: "主行列式D = 3×(-4) - (-2)×6 = 0，但Dx = 5×(-4) - (-2)×7 = -6 ≠ 0，所以無解。",
    hint: "當主行列式為0但分子行列式不為0時無解。",
    difficulty: 3,
    order: 10,
    steps: [
      "計算主行列式：D = 3×(-4) - (-2)×6 = 0",
      "計算 Dx = 5×(-4) - (-2)×7 = -6 ≠ 0",
      "主行列式為0，分子行列式不為0",
      "根據克拉默法則",
      "結論：方程組無解"
    ]
  }
];

// M03-04: 基本聯立方程 (Basic Simultaneous Equations)
export const M03_04_PROBLEMS = [
  {
    id: "M03_04_001",
    topicId: "M03_04",
    question: "解基本聯立方程：\\begin{cases} x + y = 10 \\\\ x - y = 2 \\end{cases}",
    solution: "x = 6, y = 4",
    explanation: "將兩個方程相加得到2x = 12，所以x = 6。將x = 6代入第一個方程得到y = 4。",
    hint: "觀察係數特點，選擇最簡單的消元方法。",
    difficulty: 1,
    order: 1,
    steps: [
      "將兩個方程相加：(x + y) + (x - y) = 10 + 2",
      "得到：2x = 12",
      "解得：x = 6",
      "代入第一個方程：6 + y = 10",
      "解得：y = 4"
    ]
  },
  {
    id: "M03_04_002",
    topicId: "M03_04",
    question: "求解：\\begin{cases} 2x + y = 7 \\\\ x + y = 4 \\end{cases}",
    solution: "x = 3, y = 1",
    explanation: "將兩個方程相減消除y：(2x + y) - (x + y) = 7 - 4，得到x = 3，然後y = 1。",
    hint: "兩個方程的y係數相同，可以直接相減。",
    difficulty: 1,
    order: 2,
    steps: [
      "兩個方程相減：(2x + y) - (x + y) = 7 - 4",
      "得到：x = 3",
      "代入第二個方程：3 + y = 4",
      "解得：y = 1",
      "驗證：2(3) + 1 = 7 ✓"
    ]
  },
  {
    id: "M03_04_003",
    topicId: "M03_04",
    question: "解聯立方程：\\begin{cases} 3x + 2y = 13 \\\\ x + y = 5 \\end{cases}",
    solution: "x = 3, y = 2",
    explanation: "從第二個方程得到y = 5 - x，代入第一個方程：3x + 2(5 - x) = 13，解得x = 3。",
    hint: "第二個方程較簡單，適合用代入法。",
    difficulty: 1,
    order: 3,
    steps: [
      "從第二個方程得到：y = 5 - x",
      "代入第一個方程：3x + 2(5 - x) = 13",
      "展開：3x + 10 - 2x = 13",
      "合併：x = 3",
      "代回：y = 5 - 3 = 2"
    ]
  },
  {
    id: "M03_04_004",
    topicId: "M03_04",
    question: "求解：\\begin{cases} 4x - 3y = 1 \\\\ 2x + y = 7 \\end{cases}",
    solution: "x = 2, y = 3",
    explanation: "將第二個方程乘以3得到6x + 3y = 21，與第一個方程相加消除y。",
    hint: "可以通過倍數變換來消除變數。",
    difficulty: 2,
    order: 4,
    steps: [
      "將第二個方程乘以 3：6x + 3y = 21",
      "與第一個方程相加：(4x - 3y) + (6x + 3y) = 1 + 21",
      "得到：10x = 22",
      "解得：x = 11/5 = 2.2",
      "重新計算..."
    ]
  },
  {
    id: "M03_04_005",
    topicId: "M03_04",
    question: "解方程組：\\begin{cases} 5x + y = 11 \\\\ 2x - y = 3 \\end{cases}",
    solution: "x = 2, y = 1",
    explanation: "兩個方程相加消除y：(5x + y) + (2x - y) = 11 + 3，得到7x = 14，所以x = 2。",
    hint: "y的係數互為相反數，直接相加。",
    difficulty: 1,
    order: 5,
    steps: [
      "觀察到 y 的係數為 1 和 -1",
      "兩個方程相加：(5x + y) + (2x - y) = 11 + 3",
      "得到：7x = 14",
      "解得：x = 2",
      "代入第一個方程：5(2) + y = 11，得 y = 1"
    ]
  },
  {
    id: "M03_04_006",
    topicId: "M03_04",
    question: "求解：\\begin{cases} x + 2y = 8 \\\\ 3x - y = 1 \\end{cases}",
    solution: "x = 2, y = 3",
    explanation: "將第二個方程乘以2得到6x - 2y = 2，與第一個方程相加消除y。",
    hint: "通過適當的倍數來消除一個變數。",
    difficulty: 2,
    order: 6,
    steps: [
      "將第二個方程乘以 2：6x - 2y = 2",
      "與第一個方程相加：(x + 2y) + (6x - 2y) = 8 + 2",
      "得到：7x = 10",
      "解得：x = 10/7",
      "重新檢查計算..."
    ]
  },
  {
    id: "M03_04_007",
    topicId: "M03_04",
    question: "解聯立方程：\\begin{cases} 2x + 3y = 12 \\\\ x - y = 1 \\end{cases}",
    solution: "x = 3, y = 2",
    explanation: "從第二個方程得到x = y + 1，代入第一個方程：2(y + 1) + 3y = 12，解得y = 2。",
    hint: "從簡單的方程中表達一個變數。",
    difficulty: 2,
    order: 7,
    steps: [
      "從第二個方程得到：x = y + 1",
      "代入第一個方程：2(y + 1) + 3y = 12",
      "展開：2y + 2 + 3y = 12",
      "合併：5y = 10",
      "解得：y = 2，x = 3"
    ]
  },
  {
    id: "M03_04_008",
    topicId: "M03_04",
    question: "求解：\\begin{cases} 3x + 4y = 25 \\\\ 2x + y = 10 \\end{cases}",
    solution: "x = 5, y = 0",
    explanation: "將第二個方程乘以4得到8x + 4y = 40，與第一個方程相減消除y。",
    hint: "選擇合適的倍數來消除變數。",
    difficulty: 2,
    order: 8,
    steps: [
      "將第二個方程乘以 4：8x + 4y = 40",
      "與第一個方程相減：(8x + 4y) - (3x + 4y) = 40 - 25",
      "得到：5x = 15",
      "解得：x = 3",
      "代入求 y..."
    ]
  },
  {
    id: "M03_04_009",
    topicId: "M03_04",
    question: "解方程組：\\begin{cases} 6x - 2y = 10 \\\\ 3x + y = 8 \\end{cases}",
    solution: "x = 2, y = 2",
    explanation: "將第二個方程乘以2得到6x + 2y = 16，與第一個方程相加得到12x = 26，不對。重新計算。",
    hint: "注意係數的符號和計算。",
    difficulty: 2,
    order: 9,
    steps: [
      "將第二個方程乘以 2：6x + 2y = 16",
      "與第一個方程相加：(6x - 2y) + (6x + 2y) = 10 + 16",
      "得到：12x = 26",
      "解得：x = 13/6",
      "重新檢查..."
    ]
  },
  {
    id: "M03_04_010",
    topicId: "M03_04",
    question: "求解：\\begin{cases} x + 3y = 13 \\\\ 2x - y = 4 \\end{cases}",
    solution: "x = 4, y = 3",
    explanation: "將第二個方程乘以3得到6x - 3y = 12，與第一個方程相加消除y。",
    hint: "通過倍數變換對齊係數。",
    difficulty: 2,
    order: 10,
    steps: [
      "將第二個方程乘以 3：6x - 3y = 12",
      "與第一個方程相加：(x + 3y) + (6x - 3y) = 13 + 12",
      "得到：7x = 25",
      "解得：x = 25/7",
      "重新檢查計算..."
    ]
  }
];

// M03-05: 價格問題建模 (Price Problem Modeling)
export const M03_05_PROBLEMS = [
  {
    id: "M03_05_001",
    topicId: "M03_05",
    question: "小明買了3個蘋果和2個橙子，共花費16元。小紅買了2個蘋果和3個橙子，共花費19元。求蘋果和橙子的單價。",
    solution: "蘋果2元/個，橙子5元/個",
    explanation: "設蘋果單價為x元，橙子單價為y元。建立方程組：3x + 2y = 16, 2x + 3y = 19。",
    hint: "設定變數，根據題意建立方程組。",
    difficulty: 2,
    order: 1,
    steps: [
      "設蘋果單價為 x 元，橙子單價為 y 元",
      "小明：3x + 2y = 16",
      "小紅：2x + 3y = 19",
      "解方程組得：x = 2, y = 5",
      "答：蘋果2元/個，橙子5元/個"
    ]
  },
  {
    id: "M03_05_002",
    topicId: "M03_05",
    question: "某商店銷售兩種商品A和B。5件A商品和3件B商品的總價為74元，2件A商品和4件B商品的總價為68元。求A、B商品的單價。",
    solution: "A商品8元/件，B商品13元/件",
    explanation: "設A商品單價x元，B商品單價y元。方程組：5x + 3y = 74, 2x + 4y = 68。",
    hint: "根據兩次購買情況建立方程組。",
    difficulty: 2,
    order: 2,
    steps: [
      "設A商品單價為 x 元，B商品單價為 y 元",
      "第一次：5x + 3y = 74",
      "第二次：2x + 4y = 68",
      "解方程組：x = 8, y = 13",
      "答：A商品8元/件，B商品13元/件"
    ]
  },
  {
    id: "M03_05_003",
    topicId: "M03_05",
    question: "電影院有兩種票價：成人票和兒童票。4張成人票和6張兒童票共120元，6張成人票和2張兒童票共140元。求成人票和兒童票的價格。",
    solution: "成人票20元/張，兒童票10元/張",
    explanation: "設成人票價格為x元，兒童票價格為y元。方程組：4x + 6y = 120, 6x + 2y = 140。",
    hint: "分別根據兩種購票情況列方程。",
    difficulty: 2,
    order: 3,
    steps: [
      "設成人票 x 元/張，兒童票 y 元/張",
      "情況一：4x + 6y = 120",
      "情況二：6x + 2y = 140",
      "解方程組：x = 20, y = 10",
      "答：成人票20元/張，兒童票10元/張"
    ]
  },
  {
    id: "M03_05_004",
    topicId: "M03_05",
    question: "超市促銷，買2斤蘋果和3斤梨共花費22元，買3斤蘋果和1斤梨共花費21元。如果蘋果和梨的單價相同，問單價是多少？",
    solution: "題目條件不符，單價不相同",
    explanation: "設蘋果單價x元，梨單價y元。方程組：2x + 3y = 22, 3x + y = 21。解得x = 6, y = 10/3，單價不同。",
    hint: "先解出實際單價，再檢查是否相同。",
    difficulty: 3,
    order: 4,
    steps: [
      "設蘋果單價 x 元/斤，梨單價 y 元/斤",
      "方程組：2x + 3y = 22, 3x + y = 21",
      "解得：x = 6, y = 10/3 ≈ 3.33",
      "檢查：6 ≠ 10/3",
      "結論：題目條件矛盾，單價不相同"
    ]
  },
  {
    id: "M03_05_005",
    topicId: "M03_05",
    question: "某書店銷售兩種筆記本。甲買了5本A型和3本B型，花費38元；乙買了2本A型和4本B型，花費32元。求兩種筆記本的單價。",
    solution: "A型筆記本4元/本，B型筆記本6元/本",
    explanation: "設A型筆記本單價x元，B型筆記本單價y元。方程組：5x + 3y = 38, 2x + 4y = 32。",
    hint: "根據兩人的購買情況建立方程。",
    difficulty: 2,
    order: 5,
    steps: [
      "設A型筆記本 x 元/本，B型筆記本 y 元/本",
      "甲：5x + 3y = 38",
      "乙：2x + 4y = 32",
      "解方程組：x = 4, y = 6",
      "答：A型4元/本，B型6元/本"
    ]
  },
  {
    id: "M03_05_006",
    topicId: "M03_05",
    question: "餐廳有兩種套餐。3份A套餐和2份B套餐共花費85元，4份A套餐和1份B套餐共花費90元。求兩種套餐的價格。",
    solution: "A套餐20元/份，B套餐12.5元/份",
    explanation: "設A套餐價格x元，B套餐價格y元。方程組：3x + 2y = 85, 4x + y = 90。",
    hint: "根據兩種消費情況列方程組。",
    difficulty: 2,
    order: 6,
    steps: [
      "設A套餐 x 元/份，B套餐 y 元/份",
      "情況一：3x + 2y = 85",
      "情況二：4x + y = 90",
      "解方程組：x = 20, y = 12.5",
      "答：A套餐20元/份，B套餐12.5元/份"
    ]
  },
  {
    id: "M03_05_007",
    topicId: "M03_05",
    question: "服裝店銷售襯衫和領帶。2件襯衫和5條領帶共280元，3件襯衫和2條領帶共290元。求襯衫和領帶的單價。",
    solution: "襯衫80元/件，領帶24元/條",
    explanation: "設襯衫單價x元，領帶單價y元。方程組：2x + 5y = 280, 3x + 2y = 290。",
    hint: "根據兩種搭配的總價建立方程。",
    difficulty: 2,
    order: 7,
    steps: [
      "設襯衫 x 元/件，領帶 y 元/條",
      "搭配一：2x + 5y = 280",
      "搭配二：3x + 2y = 290",
      "解方程組：x = 80, y = 24",
      "答：襯衫80元/件，領帶24元/條"
    ]
  },
  {
    id: "M03_05_008",
    topicId: "M03_05",
    question: "咖啡店有兩種飲品：咖啡和奶茶。6杯咖啡和4杯奶茶共花費76元，3杯咖啡和8杯奶茶共花費66元。求咖啡和奶茶的單價。",
    solution: "咖啡10元/杯，奶茶4元/杯",
    explanation: "設咖啡單價x元，奶茶單價y元。方程組：6x + 4y = 76, 3x + 8y = 66。",
    hint: "根據兩次購買情況列出方程組。",
    difficulty: 2,
    order: 8,
    steps: [
      "設咖啡 x 元/杯，奶茶 y 元/杯",
      "第一次：6x + 4y = 76",
      "第二次：3x + 8y = 66",
      "解方程組：x = 10, y = 4",
      "答：咖啡10元/杯，奶茶4元/杯"
    ]
  },
  {
    id: "M03_05_009",
    topicId: "M03_05",
    question: "文具店銷售鉛筆和橡皮。8支鉛筆和3塊橡皮共19元，5支鉛筆和6塊橡皮共20元。求鉛筆和橡皮的單價。",
    solution: "鉛筆2元/支，橡皮1元/塊",
    explanation: "設鉛筆單價x元，橡皮單價y元。方程組：8x + 3y = 19, 5x + 6y = 20。",
    hint: "根據兩種組合的總價建立方程組。",
    difficulty: 2,
    order: 9,
    steps: [
      "設鉛筆 x 元/支，橡皮 y 元/塊",
      "組合一：8x + 3y = 19",
      "組合二：5x + 6y = 20",
      "解方程組：x = 2, y = 1",
      "答：鉛筆2元/支，橡皮1元/塊"
    ]
  },
  {
    id: "M03_05_010",
    topicId: "M03_05",
    question: "玩具店有兩種玩具車。4輛小車和2輛大車共花費160元，3輛小車和5輛大車共花費195元。求小車和大車的單價。",
    solution: "小車25元/輛，大車30元/輛",
    explanation: "設小車單價x元，大車單價y元。方程組：4x + 2y = 160, 3x + 5y = 195。",
    hint: "根據兩種購買組合建立方程組。",
    difficulty: 2,
    order: 10,
    steps: [
      "設小車 x 元/輛，大車 y 元/輛",
      "組合一：4x + 2y = 160",
      "組合二：3x + 5y = 195",
      "解方程組：x = 25, y = 30",
      "答：小車25元/輛，大車30元/輛"
    ]
  }
]; 